<template>
    <div class="trail-grid-wrapper">
        <div class="trail-grid" v-show="trail" >
            <div v-if="$auth.loggedIn && !simpleView" class="editButtons full-row">
                <template v-if="editable">
                    <button class="button trail-button" @click="cancel">Cancel</button>
                    <button class="button-primary trail-button" @click="save">Save</button>
                </template>
                <button v-else-if="this.$auth.loggedIn &&!isDirty" class="button-primary trail-button" @click="editable = true">Edit</button>
                <router-link v-if="$auth.loggedIn &&  !editable" class="newTrailLink" replace to="new">
                    <button  class="button-primary trail-button">
                        New Trail
                    </button>
                </router-link>
            </div>
            <div class="prevNext full-row" v-if="!simpleView">
                <div class="previous">
                    <router-link v-if="trailCopy.previousTrailId" replace :to="trailCopy.previousTrailId.toString()" >Trail #{{trailCopy.trailOrdinal - 1}}</router-link>
                </div>
                <div class="next">
                    <router-link v-if="trailCopy.nextTrailId" replace :to="trailCopy.nextTrailId.toString()" >Trail #{{trailCopy.trailOrdinal + 1}}</router-link>
                </div>
            </div>
            <div class="trail-name full-row">
                <template v-if="simpleView">Next: </template><span v-if="trailCopy.id === 'new'">New Trail</span><span v-else>Trail #{{trailCopy.trailOrdinal}}</span>
            </div>
            <div class="label-value-row date-trail">
                <localized-string class="label" val="trail.when"/>
                <div class="date value">
                    <editableDate class="value" :editable="editable" v-model="trailCopy.trailDate"/>
                    <span v-if="trailCopy.time"> @ </span>
                    <editableTime :editable="editable" v-model="trailCopy.time"/>
                </div>
            </div>

            <div class="label-value-row" v-if="trailCopy.latitude || editable">
            <span class="label">
                <span style="cursor: pointer" @click="$emit('panMap',{lat: trailCopy.latitude, lng: trailCopy.longitude})"><localized-string val="trail.where"/></span>
            </span>
                <span class="value">
                             <editableLocation class="value location trail-location"
                                               :editable="editable"
                                               :map="map"
                                               @select="updateLocation"
                                               :locationDescription="trailCopy.trailLocation"
                                               :latitude="trailCopy.latitude"
                                               :longitude="trailCopy.longitude"
                                               @panMap="coords => $emit('panMap', coords)"
                             /><!--            0:00&nbsp;(BST)-->

            </span>

            </div>

            <!--        <div class="trail-location-name">-->
            <!--            <editableLocation :editable="editable" v-model="trailCopy.trailLocation" @selection="setLocation"/><span style="display: none" class="material-icon">G</span>-->
            <!--            &lt;!&ndash;            0:00&nbsp;(BST)&ndash;&gt;-->
            <!--        </div>-->

            <div class="hares people-list label-value-row" v-if="(this.hares && this.hares.length) || editable" >
            <span class="label">
                <span><localized-string val="trail.hare"/><template v-if="hares && hares.length !== 1">s</template></span>
                <span v-if="editable" class="material-icon" @click.stop="toggleShowAddHare(true)">person_add</span>
            </span>
                <span class="value">
              <ul>
                <li is="editableHasher" @removeHasher="removeHare" class="person" v-bind:key="hare.id" v-for="hare in this.hares" :class="{'new-hasher' : hare.isNew}" :hasher="hare" :editable="editable">
                </li>
            </ul>
            <ul>
                <li is="NewHasherBubble" v-if="showAddHare" class="person editable" v-on:select="addHare" v-on:cancel="toggleShowAddHare(false)" :alreadySelected="this.hares.concat(this.hashers)"></li>
            </ul>
            </span>
            </div>
            <div class="pack people-list label-value-row"  v-if="(this.hashers && this.hashers.length) || editable" >
            <span class="label">
                <localized-string val="trail.pack"/>
                <span v-if="editable" class="material-icon" @click.stop="toggleShowAddPack(true)">person_add</span>
            </span>
                <span class="value">
                <ul>
                    <li is="editableHasher" @removeHasher="removeHasher" class="person" v-bind:key="hasher.id" v-for="hasher in this.hashers" :class="{'new-hasher' : hasher.isNew}" :hasher="hasher" :editable="editable">
                    </li>
                </ul>
                <ul>
                    <li is="NewHasherBubble" v-if="showAddPack" class="person editable" v-on:select="addHasher" v-on:cancel="toggleShowAddPack(false)" :alreadySelected="this.hares.concat(this.hashers)"></li>
                </ul>
            </span>
            </div>
            <div v-if="trailCopy.description" class="trail-description">
            </div>


        </div>
        <div v-if="$auth.loggedIn && trailCopy.id !== 'new'  && !simpleView" class="deleteButton">
            <button class="button button-delete trail-button " @click="deleteTrail">Delete</button>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .trail-grid-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .deleteButton {
        display: flex;
        justify-content: center;
        padding-top: 3em;
        padding-bottom: 1em;
        .button-delete {
            color: red;
          background: white;
            border: red 2px solid;
        }
    }

    .full-row {
        grid-column-start: 1;
        grid-column-end: 3;
    }
  .label-value-row {
      display: contents;
      .label {
          font-size: 20px;
          font-weight: bold;
          /*margin: 0 0 0.35em 0.5em;*/
          /*align-self: flex-start;*/

          justify-self: end;
          grid-column-start: 1;
          grid-column-end: 2;
          span.material-icon {
              color: $editColor;
          }
      }
      .value {
          font-size: 20px;
          grid-column-start: 2;
          grid-column-end: 3;
          font-weight: 500;
          //Def not the right place to put this
          //padding-right: 1em;
          padding: 0;
      }
      @media only screen and (max-width: 420px) {
          .value {
              font-size: 16px;
          }
      }
  }
    .people-list  .label {
        align-self: start;
        margin-top: 0.125em;
    }


    .people-list  ul::after {
        content: '';
        flex-grow: 1000000;
    }


    .people-list  ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 0;
        //Override ul base
        //margin: 0;
        list-style: none;

        margin: 0 0 0 -0.25em;

        @media only screen and (max-width: 420px) {
            flex-direction: column;
        }
    }

    .person {
        white-space: nowrap;
        //border: 1px solid $beaverpurple;
        //color: white;
        flex-wrap: nowrap;
        margin: 0.25em 0.25em;
        //   padding: 0.25em 0.5em;
        padding: 0.15em 0.5em;
        text-align: center;
        vertical-align: center;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        //flex-wrap: wrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex-grow: 0;
        height: calc(1.65em + 2px);  //line height plus padding times 2  + 2* border
        //max-width: 50%;
        position: relative;
        max-width: 100%; //Reallllly long names
        box-sizing: border-box;
    }

    .person.editable {
        border-color: black;
        border-width: 0px;
        height: calc(1.65em + 0px);  //line height plus padding times 2  - border
        width: 100%;
        box-shadow: 0 0 2px 3px $editColor, 0 0 0px 0px $editColor inset;
        position: relative;
    }


</style>
<script>
  import _ from 'lodash-es';
  import HasherDao from "../daos/HasherDao";
  import useLoadingWrapper from "./loadingWrapper";
  import TrailDao from "../daos/TrailDao";
  import LocalizedString from "./localizedString";

  export default {
    name: 'Trail',
    components: {LocalizedString},
    props: ['trail', 'edit', 'map', 'simpleView'],
    data: function () {
      return {
        // hashers : [],  TODO: async should detect duplicates
        // hares: [],
        trailCopy: null,
        showAddHare: false,
        showAddPack: false,
        //isDirty: false,
        editable: false
      }},
    setup: function() {
      const {isLoading, loadingStart, loadingDone} = useLoadingWrapper();
      return {isLoading, loadingStart, loadingDone};
    },
    beforeMount() {
      this.loadingStart();
    },
    methods: {
      toggleShowAddHare(isShow) {
        this.showAddHare = isShow;
      },
      toggleShowAddPack(isShow) {
        this.showAddPack = isShow;
      },
      addHare(hasher) {
        hasher.isNew = true;
        this.trailCopy.hareIds.push(hasher.id);
      },
      addHasher(hasher) {
        hasher.isNew = true;
        this.trailCopy.hasherIds.push(hasher.id);
      },
      removeHare(hasherToRemove) {
        hasherToRemove.isNew = false;
        if (window.confirm(`Remove ${hasherToRemove.hash_name} from this trail?`)) {
          let index = _.indexOf(this.trailCopy.hareIds, hasherToRemove.id);
          this.trailCopy.hareIds.splice(index, 1);
          this.trailDirty = true;
        }
      },
      removeHasher(hasherToRemove) {
        hasherToRemove.isNew = false;
        if (window.confirm(`Remove ${hasherToRemove.hash_name} from this trail?`)) {
          let index = _.indexOf(this.trailCopy.hasherIds, hasherToRemove.id);
          this.trailCopy.hasherIds.splice(index, 1);
          this.trailDirty = true;
        }
      },
      updateLocation(googlePlacePromise) {
        this.loading++;
        googlePlacePromise.then(place => {
          this.trailCopy.latitude = place.geometry.location.lat();
          this.trailCopy.longitude = place.geometry.location.lng();
          this.trailCopy.trailLocation = place.description;
          this.$emit('panMap', {lat: this.trailCopy.latitude, lng: this.trailCopy.longitude});
          this.$emit('newLocationMarker', {lat: this.trailCopy.latitude, lng: this.trailCopy.longitude});
          this.loading--;
        })
      },
      resetNewHaresHashers() {
        this.hashers.concat(this.hares).forEach(hasher => hasher.isNew = false);
      },
      cancel() {
        this.resetNewHaresHashers();
        if (this.trailCopy.id === "new") {
          this.$emit('cancelNewTrail');
        } else {
          this.trailCopy = _.cloneDeep(this.trail);
        }
        //this.isDirty = false;
        this.editable = false;
      },
      save() {
        this.resetNewHaresHashers();
        if (!this.isDirty) {
          this.$emit('savedTrail');
          this.editable = false;
        } else {
          TrailDao.save(this.trailCopy).then(savedTrail => {
            this.$emit('savedTrail', savedTrail);
            this.editable = false;
            this.trailCopy = _.cloneDeep(savedTrail);
          });
        }
      },
      deleteTrail() {
        if (window.confirm("Are you sure you want to delete this trail? This cannot be undone.")) {
          TrailDao.delete(this.trailCopy.id).then(() => {
            this.$emit('deletedTrail', this.trailCopy.id);
          });
        }
      }
    },
    asyncComputed: {
      //Todo - change grouped promise to array of promises, also add default: []
      hares() {
        return HasherDao.fetchByIds(this.trailCopy.hareIds).then(hares => {
            return _.sortBy(hares, hare => hare.hash_name);
          }
        );
      },
      hashers() {
        return  HasherDao.fetchByIds(this.trailCopy.hasherIds).then(hashers => {
            return _.sortBy(hashers, hasher => hasher.hash_name);
          }
        );

      }
    },
    computed: {
      isDirty() {
        return !_.isEqual(this.trailCopy, this.trail) || this.trailCopy.id === "new"
      }
    },
    watch: {
      // trailCopy : {
      //   deep: true,
      //   handler: function() {
      //     if (_.isEqual(this.trailCopy, this.trail)) {
      //       this.dirty = false;
      //     } else {
      //       this.isDirty = true;
      //       console.log("trail now dirty");
      //     }
      //     if (newTrail && oldTrail && newTrail.id === oldTrail.id) {
      //     }
      //   }
      // },
      trail : {
        //TODO: make sure we don't destroy data
        immediate: true,
        handler: function(newTrail, oldTrail) {
          if (!newTrail) {
            this.trailCopy = null;
          } else if (oldTrail && newTrail.id === oldTrail.id && this.isDirty) {
            console.log("External changes to trail while editing in progress. Probably nothing");
          } else {
            //Fetch all hashers at once -  almost certainly premature optimization
            HasherDao.fetchByIds(newTrail.hareIds.concat(newTrail.hasherIds));
            this.trailCopy = _.cloneDeep(this.trail);
            //this.isDirty = false;
            if (newTrail.id === "new") {
              this.editable = true;
              //this.isDirty = true;
            }
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">


    .new-hasher {
        background: lightgreen;
        color: black;
        /*border-color: green;*/
        /*border-width: 1.5px;*/
    }
    /*.trail-grid {*/
    /*    display: grid;*/
    /*    grid-template-columns:  5em 1fr 1fr 5em;   // Todo math subtract column 2 from 1*/
    /*    //    grid-template-rows:  24px 24px 24px auto auto auto;*/
    /*    //grid-column-gap: 2em;*/
    /*    //grid-row-gap: .5em;*/
    /*    align-content: start;*/
    /*    justify-content: center;*/
    /*    justify-items : center;*/
    /*    align-items: baseline;*/
    /*    grid-template-areas:*/
    /*            "prevNext"*/
    /*            "trail-name"*/
    /*            "trail-date"*/
    /*            "trail-time"*/
    /*            "trail-location"*/
    /*            "hares"*/
    /*            "map"*/
    /*            "pack"*/
    /*            "desc";*/

    /*    //border: 1px solid $beaverpurple;*/
    /*    //border-radius: 6px;*/
    /*    padding : 1em 2em 1em 2em;*/
    /*}*/

    .trail-grid {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        /*    align-content: start;*/
        /*    justify-content: center;*/
        /*    justify-items : center;*/
        align-items: center;
        grid-column-gap: 1rem;
        grid-row-gap: 1rem;
        border-style : none;
        padding: 0;
    }
    .prevNext {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        align-items: center;
        width: 100%;
        position: sticky;
        padding-top: 1em;
        padding-bottom: .5em;
    }

    .editButtons {
        display: flex;
        justify-content: center;
        margin-top: 1em;
        margin-bottom: -1em; //TODO why?
    }

    .previous {
        justify-self: start;
        margin-left: 3em;
        a {
            text-decoration: none;
            font-weight: bold;
        }
    }
    .next {
        justify-self: end;
        margin-right: 3em;
        a {
            text-decoration: none;
            font-weight: bold;
        }
    }
    .trail-name {
        margin-bottom: 0.5em;
        display: flex;
        justify-content: center;
    }
    /*.trail-name, .trail-date, .trail-time, .trail-location {*/
    /*    justify-self : left;*/
    /*    //height: 100%;*/
    /*    width: 100%;*/
    /*    max-width: 100%;*/
    /*}*/
    .trail-name {
        font-size: 2.25rem;
        padding: 0;
        font-weight: bold;
    }
    /*.trail-date, .trail-time {*/
    /*    padding: 0;*/
    /*    font-size: 18px;*/
    /*    font-weight: bold;*/
    /*}*/

    .trail-location > input {
        text-align: center;
        //padding-bottom: 1em;
    }


    .trail-description {
        font-size: 20px;
        margin-top: 1em;
    }





</style>

